import Input from "./Input";

export default class CheckBox extends Input {

    _checked;

    get checked() {
        return this._checked;
    }

    set checked(value) {
        this._checked = !!value;
        this.validate();
        this.form.onChange();
    }

    get value() {
        if (!this.checked) {
            return false;
        }

        return this._value;
    }

    constructor(element, form) {
        super(element, form);
        this._checked = this.inputElement.checked;
    }

    addListeners() {
        this.inputElement.addEventListener('change', () => {
            this.checked = this.inputElement.checked;
        });
    }

    reset() {
        this.checked = false;
        this.removeError();
    }
}
